import { AllianzAccountStatementEntity } from '../entities/allianz-account-statement-entity';

export default class State {
  loaded = false;

  items: Array<AllianzAccountStatementEntity> = [];
}
